module.exports = __webpack_public_path__ + "img/victrix-bretelle-7.2ff87b03.jpg";